export default "__VITE_ASSET__C$vZ4yRe__"